import usePageNavigationHook from '@/hooks/usePageNavigation.js';

const useLogoHook = () => {
  const { indexRouteName, redirectTo } = usePageNavigationHook();

  const headerLogoSrc = '/static/images/header-menu/icons_logo.svg';

  const redirectToIndexPage = () => {
    redirectTo(indexRouteName.value);
  };

  return {
    headerLogoSrc,
    redirectToIndexPage,
  };
};

export default useLogoHook;
